import React from 'react';
import { logoUrl } from '../content/siteContent';

function Brand({ compact = false }) {
  return (
    <a
      className={`brand ${compact ? 'brand--compact' : ''}`}
      href="#inicio"
      aria-label="Muchacho E’ Mandao, volver al inicio"
    >
      <img
        className="brand__logo"
        src={logoUrl}
        alt="Logo de Muchacho E’ Mandao"
      />
      <span className="brand__copy">
        <strong>Muchacho E’ Mandao</strong>
        <small>Tú pide, nosotros resolvemos</small>
      </span>
    </a>
  );
}

export default Brand;